// extracted by mini-css-extract-plugin
export default {"container":"searchItems_container__UBIk-"};